import { defineMessages } from 'react-intl';

export default defineMessages({
  AllInYearlyFeesYearlyFees: {
    id: 'AllInYearlyFeesYearlyFees',
    defaultMessage: 'Yearly fees',
  },
});
